export default "__VITE_ASSET__DH1fvrm8__"